const { __, __x, __nx, __N } = JIX.Gettext;

export default {
    start: () =>
        __('Startdato'),
    end: () =>
        __('Slutdato'),
    cancel: () =>
        __('Annuller'),
    show: () =>
        __('Vis'),
};
